
import React, { useState } from 'react';
import CircleSection from '../../Helpers/Circles/CircleSection';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import './Marketing.scss';

function TextContent(props) {
  return props.text.map((t, index) =>
    <div key={index} className="text w-100">
      <div>
        {t.icon}
      </div>
      {t.title && <h2>{t.title}</h2>}
      {t.paragraphs.map((p, index) =>
        <p key={index} className="mt-2">{p}</p>
      )}
      {t.link &&
        <Button variant="text" color="primary" className="btn btn-link" onClick={() => props.openModal(t.modalContent)} >{t.link}</Button>
      }
    </div>);
}

export default function Marketing(props) {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const openDialog = (content) => {
    setDialogOpen(true);
    setModalContent(content);
  }

  const data = props.data.map((d, index) => ({
    image: d.image,
    imageClass: d.imageClass ? d.imageClass : '',
    textContent: <TextContent key={index} text={d.text} openModal={openDialog} />
  }));

  return (
    <div className="marketing-section justify-content-center">
      <CircleSection data={data} />
      <LearnMoreDialog
        open={isDialogOpen}
        onDialogClosed={() => {
          setDialogOpen(false);
        }}
        content={modalContent}
      />
    </div>
  );
};

function LearnMoreDialog(props) {
  return (
    <div>
      <Dialog maxWidth="sm" open={props.open} onClose={props.onDialogClosed} scroll="body">
        <DialogContent className="product-info-dialog-content">
          <IconButton className="product-info-close-button" aria-label="close" onClick={props.onDialogClosed}>
            <CloseIcon />
          </IconButton>
          {props.content}
        </DialogContent>
      </Dialog>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/Marketing/Marketing.js